import { createSelector, createFeatureSelector } from '@ngrx/store';
import * as fromRoot from '../../../app/state/app.selectors';
import * as fromHome from './home.reducers';

export interface HomeState {
  stateData: fromHome.State;
}

export interface State extends fromRoot.AppState {
  home: HomeState;
}

export const reducers = {
  stateData: fromHome.reducer
};

export const selectHomeState = createFeatureSelector<HomeState>('home');

export const selectHomeStateData = createSelector(selectHomeState, (state: HomeState) => state.stateData);


export const getUserInt = createSelector(selectHomeStateData, fromHome.getUserInt);

export const getUserExt = createSelector(selectHomeStateData, fromHome.getUserExt);


export const getHomeScreenError = createSelector(selectHomeStateData, fromHome.getError);

export const getHomeScreenPending = createSelector(selectHomeStateData, fromHome.getPending);


export const getFormCCExceptDraft = createSelector(selectHomeStateData, fromHome.getFormCCExceptDraft);

export const getFormCCPendingApproval = createSelector(selectHomeStateData, fromHome.getFormCCPendingApproval);

export const getFormCCApproved = createSelector(selectHomeStateData, fromHome.getFormCCApproved);


export const getFormMGExceptDraft = createSelector(selectHomeStateData, fromHome.getFormMGExceptDraft);


export const getFormCGExceptDraft = createSelector(selectHomeStateData, fromHome.getFormCGExceptDraft);

export const getFormCGPendingApproval = createSelector(selectHomeStateData, fromHome.getFormCGPendingApproval);

export const getFormCGApproved = createSelector(selectHomeStateData, fromHome.getFormCGApproved);


export const getFormESExceptDraft = createSelector(selectHomeStateData, fromHome.getFormESExceptDraft);

export const getFormESPendingApproval = createSelector(selectHomeStateData, fromHome.getFormESPendingApproval);

export const getFormESApproved = createSelector(selectHomeStateData, fromHome.getFormESApproved);


export const getFormPPExceptDraft = createSelector(selectHomeStateData, fromHome.getFormPPExceptDraft);

export const getFormPPPendingApproval = createSelector(selectHomeStateData, fromHome.getFormPPPendingApproval);

export const getFormPPApproved = createSelector(selectHomeStateData, fromHome.getFormPPApproved);



// export const getFormCIExceptDraft = createSelector(selectHomeStateData, fromHome.getFormCIExceptDraft);

// export const getFormCIPendingApproval = createSelector(selectHomeStateData, fromHome.getFormCIPendingApproval);

// export const getFormCIApproved = createSelector(selectHomeStateData, fromHome.getFormCIApproved);


// export const getFormFOExceptDraft = createSelector(selectHomeStateData, fromHome.getFormFOExceptDraft);

// export const getFormFOPendingApproval = createSelector(selectHomeStateData, fromHome.getFormFOPendingApproval);

// export const getFormFOApproved = createSelector(selectHomeStateData, fromHome.getFormFOApproved);